import { Actions } from './street-types.actions'
import { fromJS } from 'immutable'
import * as StreetTypesTypes from './street-types.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createStreetType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateStreetType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function streetTypesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case StreetTypesTypes.UPDATE_STREET_TYPE_REQUEST: {
      return state.setIn(['updateStreetType', 'isLoading'], true)
    }

    case StreetTypesTypes.UPDATE_STREET_TYPE_SUCCESS: {
      return state.setIn(['updateStreetType', 'isLoading'], false)
    }

    case StreetTypesTypes.UPDATE_STREET_TYPE_FAILURE: {
      return state.setIn(['updateStreetType', 'isLoading'], false)
    }

    case StreetTypesTypes.CREATE_STREET_TYPE_REQUEST: {
      return state.setIn(['createStreetType', 'isLoading'], true)
    }

    case StreetTypesTypes.CREATE_STREET_TYPE_SUCCESS: {
      return state.setIn(['createStreetType', 'isLoading'], false)
    }

    case StreetTypesTypes.CREATE_STREET_TYPE_FAILURE: {
      return state.setIn(['createStreetType', 'isLoading'], false)
    }

    case StreetTypesTypes.DELETE_STREET_TYPE_REQUEST: {
      return state
    }

    case StreetTypesTypes.DELETE_STREET_TYPE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case StreetTypesTypes.DELETE_STREET_TYPE_FAILURE: {
      return state
    }

    case StreetTypesTypes.FETCH_STREET_TYPES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case StreetTypesTypes.FETCH_STREET_TYPES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case StreetTypesTypes.FETCH_STREET_TYPES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case StreetTypesTypes.FETCH_STREET_TYPE_REQUEST: {
      return state.setIn(['updateStreetType', 'isLoading'], true)
    }

    case StreetTypesTypes.FETCH_STREET_TYPE_SUCCESS: {
      return state
        .setIn(['updateStreetType', 'isLoading'], false)
        .setIn(
          ['updateStreetType', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case StreetTypesTypes.FETCH_STREET_TYPE_FAILURE: {
      return state.setIn(['updateStreetType', 'isLoading'], false)
    }

    case StreetTypesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case StreetTypesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
